import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/applicationContext';
import { CancellationTokenManager } from '../../../shared/utils/cancellationTokenManager';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    cancellationTokenManager: new CancellationTokenManager(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
  };
};
